// Desktop/OS notification for an incoming chat message — a best-effort complement to the
// in-app chime (see notificationSound.js). No-ops silently whenever it can't help: unsupported
// browser, permission not granted, or the chat tab is already the one being looked at.
// `tag` groups notifications that should replace one another - callers outside chat pass their
// own so an incoming message and, say, an approval request don't overwrite each other's popup.
const showMessageNotification = (title, body, tag = 'chat-message') => {
    if (!('Notification' in window) || Notification.permission !== 'granted') return;
    if (document.visibilityState === 'visible' && document.hasFocus()) return;

    try {
        const notification = new Notification(title || '', { body: body || '', tag });
        notification.onclick = () => {
            window.focus();
            notification.close();
        };
    } catch (error) { /* some browsers (e.g. iOS Safari) throw on `new Notification` — skip silently */ }
}

export default showMessageNotification;
